import { graphql } from 'react-relay';

/**
 * Enqueue an operator-triggered listings crawl (pv-frontend#163) — `ALL_SITES` or
 * a single `SINGLE_SITE` run. Idempotent w.r.t. the single active run: if a run is
 * already queued or running the backend returns that in-flight run instead of
 * stacking a second, so the caller reconciles against whatever run comes back.
 * Returns the run's full summary shape so the list can adopt it immediately.
 */
export const requestListingCrawlMutation = graphql`
    mutation requestListingCrawlMutation($scope: CrawlRunScope!, $siteId: UUID) {
        requestListingCrawl(scope: $scope, siteId: $siteId) {
            id
            trigger
            requestedByOperator
            scope
            siteId
            status
            requestedUtc
            startedUtc
            completedUtc
            sitesCrawled
            listingsAdded
            listingsUpdated
            listingsUnchanged
            listingsMissed
            listingsDelisted
            rejectsQueued
        }
    }
`;
